import React, { useContext } from 'react';
import AllComponents from '../components/AllComponents';
import { Link, useParams } from 'react-router';
import { apiValue } from '../Data/AllData';
import { CartProvider, useCart } from 'react-use-cart';

function AddSingleCart() {
  const { addItem } = useCart();

  const { id } = useParams();
  const data = useContext(apiValue);
  return (
    <div>
      <div className="section properties mt-5">
        <div className="container-fluid">
          <div className="properties-box">
            {data.map((product) => {
              return product.id == id ? (
                <div className="item row">
                  <div className="col-lg-6">
                    <img
                      src={product.image}
                      height={'450px'}
                      className="w-100"
                      alt=""
                    />
                  </div>
                  <div className="col-lg-6">
                    <span className="category">{product.name}</span>
                    <h6>${product.price}</h6>
                    <h4 className="text-center">{product.description}</h4>
                    <ul className="text-center d-flex flex-column gap-3 mb-0">
                      <li>
                        Id: <span>{product.id}</span>
                      </li>
                      <li>
                        Location: <span>{product.location}</span>
                      </li>
                      <li>
                        Bedrooms: <span>{product.bedrooms}</span>
                      </li>
                      <li>
                        Bathrooms: <span>{product.bathrooms}</span>
                      </li>
                      <li>
                        Area: <span>{product.area}</span>
                      </li>
                      <li>
                        Rating: <span>{product.rating}</span>
                      </li>
                    </ul>
                    <div className="main-button">
                      <button
                        className="d-bloxk btn mb-3 orangebtn w-75 m-auto d-block"
                        onClick={() => addItem(product)}
                      >
                        ADD TO CART
                      </button>
                      <Link
                        className="d-block w-75 m-auto"
                        onClick={() => addItem(product)}
                        to="/products"
                      >
                        Back
                      </Link>
                    </div>
                  </div>
                </div>
              ) : null;
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

function SingleProduct() {
  return (
    <CartProvider>
      <AllComponents />
      <AddSingleCart />
    </CartProvider>
  );
}

export default SingleProduct;
